module.exports = __webpack_public_path__ + "static/media/patagoniaLogo2.aca8b229.png";